import React from 'react';
import denormalize from 'json-api-denormalizer';
import { reduxForm } from 'redux-form';
import _ from 'lodash';
import { connect } from 'react-redux';
//const NgssSearchFormContainer = ({ children, initialValues, searchFormValues, modules, module }) => {
class NgssSearchFormContainer extends React.Component {
  childProps = ()=> {
    const { initialValues, searchFormValues, modules, module } = this.props
    return {
      searchFormValues,
      modules,
      module,
      initialValues,
      dimensionCollection: this.getDimensionCollection(),
      results: this.getSearchResults()
    }
  }

  // Creates lists for the search select fields by iterating over all content and only collecting
  // tags that are relevant to
  getDimensionCollection = ()=> {
    let dimensions = {
      dcis: [],
      seps: [],
      cccs: [],
      pes: []
    }

    _.each(this.getAvailableContent(), (content,index)=>{
      _.each(content.ngss_dcis, (dci,dimension)=>dimensions.dcis.push(dimension))
      _.each(content.ngss_seps, (sep,dimension)=>dimensions.seps.push(dimension))
      _.each(content.ngss_cccs, (ccc,dimension)=>dimensions.cccs.push(dimension))
      _.each(content.ngss_pes, pe=>dimensions.pes.push(pe.code))
    })

    dimensions.dcis = _.orderBy(_.uniq(dimensions.dcis), dci=>dci)
    dimensions.seps = _.orderBy(_.uniq(dimensions.seps), sep=>sep)
    dimensions.cccs = _.orderBy(_.uniq(dimensions.cccs), ccc=>ccc)
    dimensions.pes = _.orderBy(_.uniq(dimensions.pes), pe=>pe)

    return dimensions
  }

  // Filters content from `getAvailableContent()` according to the values in the search form.
  getSearchResults = ()=> {
    const { cccs, dcis, seps, pes, contentTypes, includeEnrichment, includeNonEnrichment } = this.props.searchFormValues
    const selectionCount = _.flatMap(_.compact([cccs, dcis, seps, pes])).length
    let results = this.getAvailableContent()

    const dimensionGroups = [
      { type: 'ngss_dcis',  selected: new Set(dcis) },
      { type: 'ngss_seps',  selected: new Set(seps) },
      { type: 'ngss_cccs',  selected: new Set(cccs) },
      { type: 'ngss_pes',   selected: new Set(pes) }
    ]

    // Iterate over all content and remove content from `results` that does not
    // match the given search params.
    _.each(this.getAvailableContent(), content=>{
      // === Filter by content type
      if((content.type === 'quests' && !_.includes(contentTypes, '1')) || (content.type === 'sequences' && !_.includes(contentTypes, '2')) || (content.type === 'modules' && !_.includes(contentTypes, '3'))) {
        _.remove(results, content)
        return;
      }

      // === Filter by enrichment status. Ignore sequences and modules that do not have this tag.
      if((content.ngss_enrichment && !includeEnrichment) || (!content.ngss_enrichment && !includeNonEnrichment)) {
        _.remove(results,content)
        return;
      }

      let contentArray = []
      // === Filter by dimension
      _.each(dimensionGroups, ({ type, selected })=>{
        // Don't filter by a dimension if there are no selections for that particular dimension.
        if(selected.size === 0){ return; }

        // For the given piece of content and dimension, remove dimensions from the content that
        // are not present in the form selection.
        // If no dimensions remain after filtering, then the content must not have the desired
        // dimension, so remove it from the results.
        contentArray = (type === 'ngss_pes' ? _.map(content[type], pe=>pe.code) : Object.keys(content[type] || {})) || []
        if((contentArray.filter(dimension => selected.has(dimension))).length === 0) {
          _.remove(results, content)
          return;
        }
      })
    })

    return _.orderBy(results, ['type', 'name', 'title'], ['desc', 'asc', 'asc'])
  }

  getAvailableContent = ()=> {
    const { searchAll, modules, module } = this.props

    // The content to search through depends on whether the search is being done across ALL modules
    // or only a single module.
    //
    // For quests to be considered available, they must not be in_progress and must also be assignable.
    // For sequences to be considered available, they must have at least 1 quest and not have any in_progress quests.
    let content;
    if(_.isEmpty(module)) {
      let sequences = _.flatMap(modules, module=>module['sequences'])
      let quests = _.flatMap(modules, module=>module['quests'].filter(q => !q.in_progress && q.assignable_via_quest_card))

      // unless Search All, filter out quests that are part of a sequence
      if(!searchAll){ quests.filter(q => !_.find(_.flatMap(sequences, sequence=>sequence['quests']), questFromSequence=>questFromSequence.id === q.id)) }

      // filter out in-progress sequences AFTER in-progress ones have already been used to filter quests
      sequences = sequences.filter(s => s['quests'].filter(q => q.in_progress).length === 0 && s['quests'].length > 0)
      quests = this.defineQuestTypes(quests, _.map(sequences, sequence=>sequence['quests']))
      content = [modules, sequences, quests]
    } else {
      let sequences = module['sequences']
      const quest_sequences = _.map(sequences, sequence=>sequence['quests'])
      let quests = module['quests'].filter(q => !q.in_progress && q.assignable_via_quest_card).filter(q => !_.includes(quest_sequences, q))

      // unless Search All, filter out quests that are part of a sequence
      if(!searchAll){ quests = quests.filter(q => !_.find(_.flatMap(sequences, sequence=>sequence['quests']), questFromSequence=>questFromSequence.id === q.id)) }

      // filter out in-progress sequences AFTER in-progress ones have already been used to filter quests
      sequences = sequences.filter(s => s['quests'].filter(q => q.in_progress).length === 0 && s['quests'].length > 0)
      quests = this.defineQuestTypes(quests, quest_sequences)
      content = [[], sequences, quests]
    }

    return _.flatMap(content)
  }
  //this function still needs work
  defineQuestTypes = (quests, quest_sequences)=> {
    var output_quests = quests;
    var flat_quest_sequences = _.flatMap(quest_sequences);

    _.map(output_quests,quest =>{
      var is_sequence_quest = false;
      for (var i = 0; i < flat_quest_sequences.length; i++) {
        if (quest.id === flat_quest_sequences[i].id) {
          is_sequence_quest = true
          break;
        }
      }
      if (is_sequence_quest)
        quest.quest_type = 'Sequence Quest';
      else if (quest.ngss_enrichment)
        quest.quest_type = 'Enrichment Quest';
      else
        quest.quest_type = 'Practice Quest';
    })
    return output_quests
  }

  render() {
    return(
      <div className='ngss-form-container'>{React.cloneElement(React.Children.only(this.props.children), this.childProps())}</div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const modules = (denormalize(state.api) || {})['modules']
  const moduleId = state.modulesRouting.moduleId
  const defaultInitialValues = {
    includeQuests: true,
    includeSequences: false,
    includeModules: false,
    includeEnrichment: false,
    includeNonEnrichment: false,
    contentTypes: ['1','2']
  }

  return {
    modules,
    module: moduleId ? (modules || {})[moduleId] : {},
    searchFormValues: (state.form.ngssSearchForm || {}).values || {},
    initialValues: Object.assign({}, defaultInitialValues, ownProps.initialValues)
  }
}

NgssSearchFormContainer = reduxForm({ form: 'ngssSearchForm', enableReinitialize: true })(NgssSearchFormContainer);
export default connect(mapStateToProps)(NgssSearchFormContainer);
